const ArrowRightNav = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z"
      fill={props.fill || "#041420"}
    />
    <path
      d="M17.1523 11.6464C17.3476 11.8417 17.3476 12.1582 17.1523 12.3535L12.7988 16.707L12.0918 15.9999L15.5928 12.499H6.69922V11.499H15.5908L12.0918 7.99994L12.7988 7.29291L17.1523 11.6464Z"
      fill="currentColor"
    />
  </svg>
);

export { ArrowRightNav };
